import { render, staticRenderFns } from "./AppBurgerBody.vue?vue&type=template&id=0cca88f2&"
import script from "./AppBurgerBody.vue?vue&type=script&lang=js&"
export * from "./AppBurgerBody.vue?vue&type=script&lang=js&"
import style0 from "./AppBurgerBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports